export const NAVIGATION_ID = 'REACT_NAVIGATION_ID';
